<template>
  <svg class="svg-icon" v-bind:class="name" v-bind:style="{ width: width, height: height }">
    <use v-bind:xlink:href="href"></use>
  </svg>
</template>

<script>
export default {
  name: 'svg-icon',
  props: ['name', 'width', 'height'],
  computed: {
    href () {
      return '#' + this.name
    }
  }
}
</script>

<style lang="sass">
  .svg-icon
    height: 2.4rem
    width: 2.4rem
    fill-rule: evenodd
    clip-rule: evenodd
    stroke-linejoin: round
    stroke-miterlimit: 1.41421
    fill: $primary

    &.danger
      fill: $red

    &.success
      fill: $green
</style>



// WEBPACK FOOTER //
// src/views/base/SvgIcon.vue